// extracted by mini-css-extract-plugin
export default {"PagePaginationFrame":"OrderShow_PagePaginationFrame__CopNF"};